/**
 * Echo Hunt -- the per-role "test call" prompt (P3 dev tool).
 *
 * VISIBILITY-MATRIX ROW (§16.0): none -- this prompt carries no corpus, no story, no world and no
 * labels at all. It exists only so the Settings tab can verify that a role's configured model is
 * reachable and can return well-formed JSON.
 */
import {JSONSchemaLike} from "../LLM.js";
import {LLMRole, LLMRole_labels} from "../Roles.js";

export function TestCall_SystemPrompt(): string {
	return "You are a connectivity test for an app's LLM configuration. Reply with JSON only.";
}

export function TestCall_UserPrompt(role: LLMRole): string {
	return [
		`This is a configuration test for the pipeline role "${LLMRole_labels[role]}" (${role}).`,
		"",
		"Reply with a single JSON object, no prose and no code fences, of this exact shape:",
		`{"ok": true, "role": "${role}", "note": "<one short sentence, max 12 words, confirming you can reply>"}`,
	].join("\n");
}

/** The test schema with the `role` enum narrowed to the role being tested. Passing it to `CallLLM`
 * exercises the same JSON extract/parse/validate/retry path that the real pipeline prompts use. */
export function TestCall_SchemaFor(role: LLMRole): JSONSchemaLike {
	return {
		type: "object",
		required: ["ok", "role", "note"],
		properties: {
			ok: {type: "boolean"},
			role: {type: "string", enum: [role]},
			note: {type: "string", minLength: 1},
		},
	};
}
